import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-24 md:py-32">
        <div className="text-center max-w-lg">
          <div className="text-7xl md:text-9xl font-black text-primary-300 select-none">404</div>
          <h1 className="mt-4 text-xl md:text-2xl font-bold text-foreground-950">
            这个页面好像还没被创建
          </h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            别担心，可能只是链接走丢了。你可以回到首页，继续逛逛社区里的精彩话题。
          </p>
          <div className="mt-8 flex items-center justify-center gap-3 flex-col sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-full border border-background-300 text-foreground-800 hover:bg-background-100 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line" />
              搜索话题
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}